module.exports = __webpack_public_path__ + "static/media/mysql.0b5bd1b7.svg";